import { IFileAttachment } from "../core/contracts/IAttachment";
import { FileContent } from "../core/contracts/UploadedFile";

export class UploadedFileCollection {
    private _uploadedFiles: FileContent[] = [];

    constructor(files: FileContent[]) {
        this._uploadedFiles = files;
    }

    public convertToFileAttachments(): IFileAttachment[] {
        return this._uploadedFiles.map((file) => {
            return { base64: file.base64, fileName: file.name };
        });
    }
}
